import { getCSRFToken } from "./authService";

export const getStencilWeekData = async () => {
  const response = await fetch("/api/stencil_week", {
    method: "GET",
    credentials: "include",
  });
  const data = await response.json();
  return data;
};

export const getStencilWeek = async (week_num, stencil_id) => {
  const response = await fetch(`/api/stencil_week/${stencil_id}/${week_num}`, {
    method: "GET",
    credentials: "include",
  });
  const data = await response.json();
  return data;
};

// Use to select stencil for a given week
export const selectStencil = async (week_num, stencil_id) => {
  try {
    const token = await getCSRFToken();

    const form = new FormData();
    form.append("week_num", week_num);
    form.append("stencil_id", stencil_id);

    const response = await fetch("/api/stencil_week", {
      method: "POST",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
      body: form,
    });

    return response;
  } catch (error) {
    console.error("Error selecting stencil:", error);
  }
};

// Use to unselect stencil for a given week
export const unselectStencil = async (week_num, stencil_id) => {
  const token = await getCSRFToken();

  try {
    const response = await fetch(
      `/api/stencil_week/${stencil_id}/${week_num}`,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "x-csrf-token": token,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error unselecting stencil:", error);
  }
};

/** Use to start the timer for a tencil week and update the step's status to in-progress
 * Step: 1 (cut), 2 (traced), 3 (carved)
 */
export const startTimer = async (
  week_num,
  stencil_id,
  volunteer_name,
  step
) => {
  try {
    const token = await getCSRFToken();

    const form = new FormData();
    form.append("volunteer_name", volunteer_name);

    const response = await fetch(
      `/api/stencil_week/start-timer/${stencil_id}/${week_num}/${step}`,
      {
        method: "PATCH",
        credentials: "include",
        headers: {
          "x-csrf-token": token,
        },
        body: form,
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating stencil week:", error);
  }
};

/** Use to end the timer for a tencil week and update the step's status to complete
 * Step: 1 (cut), 2 (traced), 3 (carved)
 */
export const endTimer = async (week_num, stencil_id, step) => {
  try {
    const token = await getCSRFToken();

    const response = await fetch(
      `/api/stencil_week/end-timer/${stencil_id}/${week_num}/${step}`,
      {
        method: "PATCH",
        credentials: "include",
        headers: {
          "x-csrf-token": token,
        },
      }
    );

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating stencil week:", error);
  }
};

// Use to update status of stencil_week
export const updateStencilWeek = async (
  week_num,
  stencil_id,
  printed,
  cut,
  traced,
  carved
) => {
  try {
   const token = await getCSRFToken();

    const form = new FormData();
    form.append("printed", printed);
    form.append("cut", cut);
    form.append("traced", traced);
    form.append("carved", carved);

    const response = await fetch(
      `/api/stencil_week/${stencil_id}/${week_num}`,
      {
        method: "PATCH",
        credentials: "include",
        headers: {
          "x-csrf-token": token,
        },
        body: form,
      }
    );

    return response;
  } catch (error) {
    console.error("Error updating stencil week:", error);
  }
};
